import { TimelineMax, Power3 } from 'gsap';

const BlendDetailsIn = (element) => {
  const chars = [...element.querySelectorAll('.blend-details__title-char')];
  const text = element.querySelector('.blend-details__text');
  const rows = [...element.querySelectorAll('.blend-details__row')];

  const tl = new TimelineMax({ paused: true });
  tl.addLabel('start')
    .staggerTo(chars, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02, 'start')
    .to(text, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 'start+=0.6')
    .staggerTo(rows, 1, {
      y: 0,
      autoAlpha: 1,
      ease: Power3.easeOut,
    }, 0.02, 'start+=0.6');
  return tl;
};

export default BlendDetailsIn;
